"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIframePidget = void 0;
var react_1 = require("react");
var utils_1 = require("@workspace/utils");
var useIframePidget = function () {
    var _a = (0, react_1.useState)(), pidget = _a[0], setPidget = _a[1];
    var isValidOrigin = function (maybeOrigin) {
        return utils_1.workspaceUrls.includes(maybeOrigin);
    };
    var messageHandler = (0, react_1.useCallback)(function (e) {
        // check origin from whitelist
        if (isValidOrigin(e.origin)) {
            // we are only interested in the widgetsettings messaage
            if (e && e.data && e.data.type && e.data.type.toLowerCase() === "pidgetload") {
                setPidget(e.data.widget);
            }
        }
    }, []);
    (0, react_1.useEffect)(function () {
        window.addEventListener("message", messageHandler);
        return function () {
            window.removeEventListener("message", messageHandler);
        };
    }, [messageHandler]);
    (0, react_1.useEffect)(function () {
        window.parent.postMessage(JSON.stringify({ type: "pidgetready" }), "*");
    }, []);
    return pidget;
};
exports.useIframePidget = useIframePidget;
